export const getMastertonData = () => ({
  name: "Masterton",
  region: "Wairarapa",
  country: "Nouvelle-Zélande",
  description: "Masterton est une sous-région viticole traditionnelle de Wairarapa, connue pour ses vignobles établis et ses vins aromatiques. Les sols alluviaux et les microclimats variés favorisent la diversité des styles.",
  type: "subregion",
  area: "200 ha",
  production: "0.02 million hectolitres",
  climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
  soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
    soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés, diversité de cépages"
  },
  wineStyles: {
    white: "Sauvignon Blanc aromatique, Chardonnay frais, Riesling minéral",
    red: "Pinot Noir fruité, tanins souples",
    rosé: "Rosés légers et fruités"
  },
  history: "Masterton est l'une des plus anciennes zones viticoles de Wairarapa, avec une tradition de production de vins de qualité depuis les années 1980.",
  foodPairing: "Poissons, fruits de mer, fromages frais, plats locaux",
  grapeVarieties: [
    { name: "Sauvignon Blanc", percentage: "35%", description: "Vins aromatiques, acidité vive" },
    { name: "Chardonnay", percentage: "25%", description: "Vins frais, équilibrés" },
    { name: "Pinot Noir", percentage: "25%", description: "Vins rouges fruités, tanins souples" },
    { name: "Riesling", percentage: "10%", description: "Vins blancs minéraux, acidité marquée" },
    { name: "Autres", percentage: "5%", description: "Pinot Gris, expérimentaux" }
  ],
  statistics: {
    totalArea: "200 ha",
    production: "0.02 million hectolitres",
    wineries: "5+ domaines",
    exportPercentage: "20%"
  },
  viticulture: "La viticulture à Masterton privilégie la diversité des cépages et la qualité. Les rendements sont modérés pour préserver la fraîcheur et l'aromatique.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "Masterton est caractérisée par ses sols alluviaux et ses microclimats variés, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "Masterton", x: 175.7, y: -40.9, color: "#8a4a8a", size: 2 }
  ]
}); 